import { helper } from '@ember/component/helper';

// This helper keeps an action from receiving any more arguments
export default helper(([action]) => () => action());